import * as Types from '../../../../__generated__/schema';

import { Notification } from '../../../graphql/fragments/Notification.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NotificationsVariables = Types.Exact<{
  input: Types.NotificationsInput;
}>;

export type Notifications = {
  notifications: {
    edges: Array<{ node: Notification }>;
    pageInfo: Pick<
      Types.NotificationsPageInfo,
      'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'
    >;
  };
};

export const NotificationsDocument = gql`
  query Notifications($input: NotificationsInput!) {
    notifications(input: $input) {
      edges {
        node {
          ...Notification
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${Notification}
`;

/**
 * __useNotifications__
 *
 * To run a query within a React component, call `useNotifications` and pass it any options that fit your needs.
 * When your component renders, `useNotifications` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotifications({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotifications(
  baseOptions: Apollo.QueryHookOptions<Notifications, NotificationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Notifications, NotificationsVariables>(NotificationsDocument, options);
}
export function useNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Notifications, NotificationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Notifications, NotificationsVariables>(NotificationsDocument, options);
}
export function useNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<Notifications, NotificationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Notifications, NotificationsVariables>(
    NotificationsDocument,
    options,
  );
}
export type NotificationsHookResult = ReturnType<typeof useNotifications>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<Notifications, NotificationsVariables>;
export function mockNotifications({
  data,
  variables,
  errors,
}: {
  data: Notifications;
  variables?: NotificationsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: NotificationsDocument, variables },
    result: { data, errors },
  };
}
